import { DirectiveType } from 'api/goodtrust/user/utils'
import { FUNERAL_DIRECTIVE_PROGRESS } from 'components/directive/funeral/funeralDirectiveProgress'
import { MEDICAL_DIRECTIVE_PROGRESS } from 'components/directive/medical/medicalDirectiveProgress'
import { PET_DIRECTIVE_PROGRESS } from 'components/directive/pet/petDirectiveProgress'
import { POA_DIRECTIVE_PROGRESS } from 'components/directive/poa/form/poaDirectiveProgress'
import { TRUST_DIRECTIVE_PROGRESS } from 'components/directive/trust/progress'
import { getDirectivePageName } from 'components/directive/utils/directiveUtils'
import { WILL_DIRECTIVE_PROGRESS } from 'components/directive/will/willDirectiveProgress'
import { NextRouter } from 'next/router'
import { matchMap, toLowerCase } from 'utils/general'

export function getNextStepUrl(router: NextRouter, directive: DirectiveType) {
  const directiveType = directive === 'POWER_OF_ATTORNEY' ? 'poa' : toLowerCase(directive)

  const directiveUrl = `/me/directive/${directiveType}/${router.query.id}`
  const pageName = getDirectivePageName(router)

  if (pageName === 'about') {
    return `${directiveUrl}/family`
  } else if (pageName === 'family') {
    return `${directiveUrl}/checkout`
  }

  const progress = matchMap(directive, {
    FUNERAL: FUNERAL_DIRECTIVE_PROGRESS,
    MEDICAL: MEDICAL_DIRECTIVE_PROGRESS,
    PET: PET_DIRECTIVE_PROGRESS,
    POWER_OF_ATTORNEY: POA_DIRECTIVE_PROGRESS,
    WILL: WILL_DIRECTIVE_PROGRESS,
    TRUST: TRUST_DIRECTIVE_PROGRESS,
  })

  const currentStepIndex =
    pageName === 'about-more' ? 0 : progress.findIndex((step) => step.url === pageName)
  const nextStepIndex = currentStepIndex + 1
  const nextStep = progress[nextStepIndex]
  const nextStepUrl = pageName === 'about-you' ? 'about-more' : nextStep?.url ?? 'review'
  return `${directiveUrl}/steps/${nextStepUrl}`
}
